import { Grid, Typography } from "@mui/material";
import IDayliPlanAppointment from "../interface/iDayliPlanAppointment";

const PhoneNumber = ({
  appointment,
}: {
  appointment: IDayliPlanAppointment;
}): React.JSX.Element => (
  <Grid
    item
    xs={6}
    sm={4}
    md={3}
    lg={3}
    sx={{
      mb: 2,
    }}
  >
    <Typography
      sx={{
        fontWeight: "bold",
      }}
      variant="caption"
      component="p"
    >
      Telefonnummer
    </Typography>
    <Typography variant="body1" component="p">
      {appointment.participantPhoneNumber}
    </Typography>
  </Grid>
);

export default PhoneNumber;
